import React, { useEffect } from 'react';
import ZonePlannerMap from '@common/components/Room/ZonePlanner/ZonePlannerMap';
import RoomDependentWrapperPage from '@common/components/Room/RoomSelectors/RoomDependentWrapperPage';
import { useAppSelector } from 'store';
import { selectRobotsData } from 'store/robots/robots-slice-selectors';
import { trackEvent } from 'services/analytics';
import { AnalyticsEvent } from 'services/analytics-events';

const MapPlannerPage: React.FC = () => {
  const robot = useAppSelector((state) => selectRobotsData(state)).currentRobot;
  const robotId = robot?.id ?? null;
  const robotSerial = robot?.serialNumber ?? null;

  useEffect(() => {
    trackEvent(AnalyticsEvent.ZonePlannerOpened, { robot_id: robotId, robot_serial: robotSerial });
  }, [robotId, robotSerial]);

  return (
    <React.Fragment>
      <RoomDependentWrapperPage>
        <ZonePlannerMap />
      </RoomDependentWrapperPage>
    </React.Fragment>
  );
};

export default MapPlannerPage;
